import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, Check } from "lucide-react";
import CutterheadLogo from "@/components/CutterheadLogo";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

// Top-left brand that doubles as a switcher between the TBM Maintenance app
// and the BoreHub × Rigging section.
export default function SectionSwitcher({ section = "tbm", onNavigate }) {
  const navigate = useNavigate();
  const go = (to) => { onNavigate?.(); navigate(to); };
  const isRigging = section === "rigging";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="section-switcher" className="flex w-full items-center gap-3 rounded-xl px-5 py-6 text-left transition-colors hover:bg-surf-3/50">
          {isRigging ? (
            <img src="/rigging-logo.png" alt="" className="h-9 w-9 shrink-0 object-contain" />
          ) : (
            <CutterheadLogo size={34} />
          )}
          <div className="min-w-0 flex-1">
            <div className="truncate text-lg font-extrabold tracking-wide text-ink">{isRigging ? "BoreHub × Rigging" : "BoreHub"}</div>
            <div className="text-[10px] uppercase tracking-widest text-ink3">{isRigging ? "Rigging" : "TBM Maintenance"}</div>
          </div>
          <ChevronDown size={16} className="shrink-0 text-ink3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[250px]">
        <DropdownMenuItem data-testid="switch-tbm" onClick={() => go("/")} className="flex items-center gap-2 py-2.5">
          <CutterheadLogo size={22} />
          <div className="flex-1">
            <div className="font-semibold">BoreHub</div>
            <div className="text-xs text-ink3">TBM Maintenance</div>
          </div>
          {!isRigging && <Check size={16} className="text-brand" />}
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="switch-rigging" onClick={() => go("/rigging")} className="flex items-center gap-2 py-2.5">
          <img src="/rigging-logo.png" alt="" className="h-[22px] w-[22px] object-contain" />
          <div className="flex-1">
            <div className="font-semibold">BoreHub × Rigging</div>
            <div className="text-xs text-ink3">Rigging gear &amp; inspections</div>
          </div>
          {isRigging && <Check size={16} className="text-brand" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
